import TextFieldsGenerator from './TextFieldsGenerator';

export default TextFieldsGenerator;
